"use client"

import { Skeleton } from "@/components/ui/skeleton"

export const EventSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 h-full p-0 m-0">
      {/* Image Skeleton */}
      <div className="col-span-1 sm:col-span-1 h-auto sm:h-full p-0 m-0">
        <Skeleton className="w-full h-[200px] sm:h-full" />
      </div>

      {/* Content Skeleton */}
      <div className="col-span-1 sm:col-span-1 h-auto sm:h-full p-0 m-0 flex flex-col justify-center px-4 sm:px-6 py-6 sm:py-0 gap-4">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-12 w-16" />
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-px w-[95%] my-6" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-5 w-24" />
      </div>
    </div>
  )
}
